

































































































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { InstanceGroup } from "@/services/instances/types";
import { getAllInstanceGroups } from "@/services/instances/instanceGroupService";
import { instanceGroupFields } from "@/components/instances/fields/instanceGroupFields";
import InstanceGroupDeleteModal from "@/components/instances/modals/InstanceGroupDeleteModal.vue";
import { RoleEnum } from "@/store/authentication/types";
const namespace: string = "authentication";

@Component({
    components: { InstanceGroupDeleteModal }
})
export default class InstanceGroups extends Vue {
    @Getter("authorize", { namespace }) authorize: any;
    roles = RoleEnum;

    // Local state
    groups = [] as Array<InstanceGroup>;
    isBusy = false;
    fields = instanceGroupFields;
    sortBy = "name";
    sortDesc = false;

    // filter options
    searchQuery = "";

    // lifecycle hooks

    public created() {
        this.fetchData();
    }

    // computed
    get filteredData() {
        return this.groups && this.groups
            .filter(x => this.searchQuery.length === 0 ||
                (x.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                    x.description.toLowerCase().includes(this.searchQuery.toLowerCase())));
    }
    // methods

    deleteInstanceGroup(groupId: string) {
        (this.$refs.instanceGroupDeleteModal as any).open(groupId);
    }

    fetchData() {
        this.isBusy = true;
        getAllInstanceGroups().then((response: any) => {
            this.groups = response;
            this.isBusy = false;
        });
    }
}
